import axiosInstance from '@/api/axiosInstance'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

const SERVICE_OFFERINGS_PATH = '/service-offerings/'

export const useServiceOfferings = () => {
    return useQuery({
        queryKey: ['service-offerings'],
        queryFn: async () => {
            const response = await axiosInstance.get(SERVICE_OFFERINGS_PATH)
            return response.data.results || response.data
        },
        staleTime: 2 * 60 * 1000,
    })
}

export const useMyOfferings = () => {
    return useQuery({
        queryKey: ['service-offerings', 'my'],
        queryFn: async () => {
            const response = await axiosInstance.get(`${SERVICE_OFFERINGS_PATH}my-offerings/`)
            return response.data
        },
        staleTime: 60 * 1000,
    })
}

export const useNearbyOfferings = (latitude?: number, longitude?: number, radius: number = 10) => {
    return useQuery({
        queryKey: ['service-offerings', 'nearby', latitude || 0, longitude || 0, radius],
        queryFn: async () => {
            if (!latitude || !longitude) return []
            const response = await axiosInstance.get(
                `${SERVICE_OFFERINGS_PATH}nearby/?latitude=${latitude}&longitude=${longitude}&radius=${radius}`
            )
            return response.data
        },
        enabled: !!latitude && !!longitude,
        staleTime: 60 * 1000,
    })
}

export const useCreateOffering = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (data: any) => {
            const response = await axiosInstance.post(SERVICE_OFFERINGS_PATH, data)
            return response.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['service-offerings', 'my'] })
            queryClient.invalidateQueries({ queryKey: ['service-offerings'] })
        },
    })
}

export const useUpdateOffering = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async ({ id, data }: { id: number, data: any }) => {
            const response = await axiosInstance.patch(`${SERVICE_OFFERINGS_PATH}${id}/`, data)
            return response.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['service-offerings', 'my'] })
            queryClient.invalidateQueries({ queryKey: ['service-offerings'] })
        },
    })
}

export const useDeleteOffering = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (id: number) => {
            await axiosInstance.delete(`${SERVICE_OFFERINGS_PATH}${id}/`)
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['service-offerings', 'my'] })
            queryClient.invalidateQueries({ queryKey: ['service-offerings'] })
        },
    })
}


